import { AxiosRequestConfigMethods } from "@/api/types";
import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";
import {
  CreateProposalDto,
  EditProposalDto,
  PreviewProposalDto,
  ProposalDetailedResponseDto,
  QueryProposalsDto,
} from "../../dtos/rental-financial-proposal";
import { FinancialProposal } from "../../types";
import { AxiosResponse } from "axios";

export const previewProposal = async (data: PreviewProposalDto) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/rental-financial-proposals/preview`,
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.POST,
      responseType: "arraybuffer",
      data,
    },
  }) as Promise<{
    data: ArrayBuffer;
    headers: Record<string, string>;
  }>;
};

export const downloadProposal = async ({ uid }: { uid: string }) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/rental-financial-proposals/${uid}/download`,
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      responseType: "arraybuffer",
    },
  }) as Promise<{
    data: ArrayBuffer;
    headers: Record<string, string>;
  }>;
};

export const createProposal = async (data: CreateProposalDto) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/rental-financial-proposals`,
  );
  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.POST,
      data,
    },
  }) as Promise<AxiosResponse<FinancialProposal>>;
};

export const editProposal = async ({ uid, ...data }: EditProposalDto) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/rental-financial-proposals/${uid}`
  );
  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.PUT,
      data,
    },
  }) as Promise<AxiosResponse<FinancialProposal>>;
};

export const findProposal = async (uid: string) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/rental-financial-proposals/${uid}`
  );
  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
    },
  }) as Promise<AxiosResponse<ProposalDetailedResponseDto>>;
};

export const queryProposals = async (data: QueryProposalsDto) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/rental-financial-proposals`
  );
  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      params: data,
    },
  }) as Promise<AxiosResponse<FinancialProposal[]>>;
};

export const extendProposal = async (uid: string) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/rental-financial-proposals/${uid}/extend`
  );
  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.POST,
    },
  }) as Promise<AxiosResponse<FinancialProposal>>;
};
